// extracted by mini-css-extract-plugin
export default {"hero":"Oth360Banner_hero__uaYkY","heroInner":"Oth360Banner_heroInner__6miE3","heroTitle":"Oth360Banner_heroTitle__AHc7J","heroActions":"Oth360Banner_heroActions__XVSRt"};